module.exports = __webpack_public_path__ + "static/media/future-precision-medicine-01.df49037b.jpg";